<template>
<div class="chapter">
<div class="inner_page">
<div class="booksection">
<p class="img"><a id="page6"><img alt="image" src="images/p6.jpg"/></a></p><a id="page6">
<p class="gallery_text">Fun and fearless ideas for role play.</p>
<p class="img"><img alt="image" src="images/p6a.jpg"/></p>
<p class="gallery_text">Steamy and sensual ways to build intimacy.</p>
<p class="img"><img alt="image" src="images/p6b.jpg"/></p>
<p class="gallery_text">Embark on an exciting journey into the sensual realm.</p>
<p class="img"><img alt="image" src="images/p6c.jpg"/></p>
<p class="gallery_text">Dress—and undress—for sexy success.</p>
</a><p class="img"><a id="page6"></a><a id="page7"><img alt="image" src="images/p6d.jpg"/></a></p><a id="page7">
<p class="gallery_text">How to make your fantasies come true.</p>
<p class="img"><img alt="image" src="images/p7.jpg"/></p>
<p class="gallery_text">All the most satisfying sex positions.</p>
<p class="img"><img alt="image" src="images/p7a.jpg"/></p>
<p class="gallery_text">Hands-on hints for teasing and pleasing.</p>
<p class="img"><img alt="image" src="images/p7b.jpg"/></p>
<p class="gallery_text">Sweetly sizzling make-out moments.</p>
<p class="img"><img alt="image" src="images/p7c.jpg"/></p>
<p class="gallery_text">Seductive secrets and saucy games.</p>
</a></div><a id="page7">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fmpart2.vue?1c1ae34f